import React from "react";

export default function IconInstagram() {
	return (
		<a href="https://www.instagram.com/ulozdoklad/" target="_blank" rel="noopener noreferrer">
			<img src="/ig.svg" alt="Instagram" />
		</a>
	);
}
